import { msg } from "@lingui/macro";
import type { MessageDescriptor } from "@lingui/core";

import type { VariableType } from "@app/types/study";

/** What a variable is, in the words a clinician reads — the picker's badge and the glossary's. */
export const VARIABLE_TYPE_LABELS: Record<VariableType, MessageDescriptor> = {
  numeric: msg`Nombre`,
  categorical: msg`Catégorie`,
  ordinal: msg`Échelle ordonnée`,
  binary: msg`Oui / non`,
  multi: msg`Plusieurs valeurs`,
  date: msg`Année`,
};

export const FAMILY_LABELS: Record<"acte" | "patient", MessageDescriptor> = {
  acte: msg`L'acte et son épisode`,
  patient: msg`Le patient`,
};
